import { NAME } from './constants';

export const APPEND_COMMUNICATION_GROUPS = `${NAME}/APPEND_COMMUNICATION_GROUPS`;
export const CHANGE_QUICK_FILTER = `${NAME}/CHANGE_QUICK_FILTER`;
export const RESET = `${NAME}/RESET`;
export const SELECT_COMMUNICATION_GROUP = `${NAME}/SELECT_COMMUNICATION_GROUP`;
export const SET_COMMUNICATION_GROUPS = `${NAME}/SET_COMMUNICATION_GROUPS`;
export const SET_SORT = `${NAME}/SET_SORT`;
